import React from 'react';

const Intro = React.createClass({
    render: function() {
        return (
            <div>
                <h1>Permissions</h1>
                <p>Specify the user group who can access SQL Clone. Users within that group will be able to create images and clones.</p>
            </div>
        );
    }
});

export default Intro;



// WEBPACK FOOTER //
// ./src/components/settings/PermissionsPage/Intro.jsx